<section id="account-bet-summary" class="tw-w-full" data-cy="bet-summary-screen">
  <form [formGroup]="getBetSummaryForm" class="bet-summary-form">
    <!-- Date From -->
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label data-cy="date-from-txt">{{ 'account.statements.datefrom' | translate: 'Date From' }}</mat-label>
      <input
        matInput
        readonly
        [matDatepicker]="fromPicker"
        [max]="maxDate"
        formControlName="dateFrom"
        (click)="fromPicker.open()"
        data-cy="date-from-input"
      >
      <mat-datepicker-toggle matIconSuffix [for]="fromPicker" data-cy="date-from-cal"/>
      <!-- Align the calendar popup to the input's right edge -->
      <mat-datepicker #fromPicker xPosition="end"/>
    </mat-form-field>

    <!-- Date To -->
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label data-cy="date-to-txt">{{ 'account.statements.dateto' | translate: 'Date To' }}</mat-label>
      <input
        matInput
        readonly
        [matDatepicker]="toPicker"
        [max]="maxDate"
        formControlName="dateTo"
        (click)="toPicker.open()"
        data-cy="date-to-input"
      >
      <mat-datepicker-toggle matIconSuffix [for]="toPicker" data-cy="date-to-cal"/>
      <!-- Align the calendar popup to the input's right edge -->
      <mat-datepicker #toPicker xPosition="end"/>
    </mat-form-field>

    <button
      mat-flat-button
      type="button"
      (click)="searchBetSummary()"
      [disabled]="getBetSummaryForm.invalid"
      [ngClass]="{ 'active': getBetSummaryForm.valid }"
      class="search-bet-summary tw-w-full"
      data-cy="search-btn"
    >
      {{ 'generic.search' | translate: 'Search' }}
    </button>
  </form>

  <!-- Results — grid ported from the legacy Bet Summary tab -->
  <div class="tw-mt-[20px] results">
    @if (rows.length) {
      <table class="bet-summary-table tw-w-full" data-cy="bet-summary-table">
        <thead>
          <tr>
            <th data-cy="col-track">{{ 'generic.track' | translate: 'Track' }}</th>
            <th data-cy="col-pool">{{ 'generic.pool' | translate: 'Pool' }}</th>
            <th data-cy="col-bet">{{ 'generic.bet' | translate: 'Bet' }}</th>
            <th data-cy="col-percent">{{ 'generic.percent' | translate: 'Percent' }}</th>
            <th data-cy="col-payout">{{ 'generic.payout' | translate: 'Payout' }}</th>
            <th data-cy="col-pl">{{ 'betsummary.profitloss' | translate: 'Profit/Loss' }}</th>
            <th data-cy="col-pl-percent">{{ 'account.statement.table.header.plpercent' | translate: 'P/L Percent' }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track trackByRow($index, row)) {
            <tr [attr.data-cy]="'bet-summary-row-' + $index">
              <td [attr.data-cy]="'item-track-' + $index">{{ row.eventName | titlecase }}</td>
              <td [attr.data-cy]="'item-pool-' + $index">{{ row.poolId }}</td>
              <td [attr.data-cy]="'item-bet-' + $index">${{ row.wagered | numberWithCommas }}</td>
              <td [attr.data-cy]="'item-percent-' + $index">{{ row.percent | number: '1.0-2' }}%</td>
              <td [attr.data-cy]="'item-payout-' + $index">${{ row.winning | numberWithCommas }}</td>
              <td [attr.data-cy]="'item-pl-' + $index">${{ row.pl | numberWithCommas }}</td>
              <td [attr.data-cy]="'item-pl-percent-' + $index">{{ row.plPercent | number: '1.0-2' }}%</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <span data-cy="bet_summary_no_records">{{ 'account.statements.norecord' | translate: 'No Records Found' }}</span>
    }
  </div>
</section>
